<template lang="pug">
    v-dialog(
        v-model="dialog"
        class="full-width w-dialog" width=500
        persistent
    )
        // Button Activator Slot
        slot(
        slot="activator"
        @click="$emit('input', dialog)"
        )
            v-btn#easyPayDialog-sendBtn(slot="activator" color="primary"
                @click="$emit('input', dialog)"
            ) Send EasyLink

        v-card#easyPayDialogCard
            div#easyPayDialogCard-closeBtn.text-xs-right
                v-btn.gtm_close(
                    icon
                    @click="closeDialog()"
                )
                    v-icon mdi-close

            v-card-text#easyPayDialogCard-text
                v-flex#loading-easyPayDialog-spinner-flex.mb-2(xs12
                    v-if="sending"
                )
                    FanLoader(
                        :loading="loading"
                        class="mt-0"
                    )
                    div(slot="loadingMsg"
                        class="full-width text-xs-center headline my-2"
                    ) Sending Easy Link...

                Send(
                    v-else-if="flowState === 'UNSENT'"
                    @send="sendEasyPayLink"
                )
                Success(
                    v-else-if="flowState === 'SENT'"
                    :src="successPlane"
                )
                    p(v-if="paymentData")   Your payment request has been sent! Please check #[strong {{ paymentData.sendTo }}] for your EasyLink and further instructions.
</template>

<script>
import Send from './EasyPayDialog/Send'
import Success from '@/components/dialogs/Success'
import FanLoader from '@/components/FanLoader'
import { createPaymentLink, emailPaymentLink, textPaymentSmsLink } from 'Helpers/c4cAPIClient'

export default {
    name: 'easy-pay-dialog',
    components: {
        Send,
        FanLoader,
        Success
    },
    data() {
        return {
            dialog: false,
            easyPayInitiated: null,
            sending: false,
            paymentData: null,
            successPlane: require('@/assets/success-plane.svg'),
        }
    },
    watch: {
      dialog() {
        const vm = this
        setTimeout(() => {
          vm.reset()
        }, 1000)
      },
    },
    computed: {
        flowState() {
        return (!this.sending && !this.easyPayInitiated)
            ? 'UNSENT'
              :  (!this.sending && this.easyPayInitiated)
            ? "SENT"
            : "UNSENT"
        },
    },
    methods: {
        closeDialog() {
            this.dialog = false
        },
        reset() {
            this.easyPayInitiated = null
        },
        async sendEasyPayLink(paymentData) {
            console.log('Step 2, Creating Payment Link')
            this.sending = true
            try {
                const easyPayData = await createPaymentLink(paymentData)
                console.log("EASYPAY DATA: ", easyPayData.data)
                console.log('Step 3, Sending Payment Link via email or sms')
                if (paymentData.sendType === 'Email') {
                    await emailPaymentLink(easyPayData.data.linkId, paymentData.sendTo)
                } else if (paymentData.sendType === 'Phone Number') {
                    const phone = this.cleanPhone(paymentData.sendTo)
                    await textPaymentSmsLink(easyPayData.data.linkId, phone)
                }
                this.paymentData = paymentData
                this.easyPayInitiated = true
                this.$emit('easyPayLinkSent')
            } catch(error) {
                // Considering adding an Error page or prompting user to try again?
                console.log(error)
            }
            this.sending = false
        },
        cleanPhone(phoneNumber) {
            return '+1' + phoneNumber.replace(/-/g, '')
        },
    }
}
</script>

<style lang="scss" scoped>

</style>